import { Box, Button } from '@mui/material';
import { AttemptsChart, Icon, SnackBarContext, StatusChart, TimeChart } from 'components';
import { ChartToolbar } from 'components/charts/chartToolbar';
import ImageList from '@mui/material/ImageList';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthStore, RoutingStore, Tree } from 'stores';
import styled from 'styled-components';
import { TreeContext } from './treeViewContainer';
import { ChartImageItem, IChartImageItemProps } from './chartImageItems';
import { ApexOptions } from 'apexcharts';


export interface IStatisticsGraphsProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

export interface IChartProps {
  preview?: boolean,
}

export interface ApexChartParams {
  dataPointIndex: number,
  seriesIndex:    number,
  w:              {config: ApexOptions},
  series:         number[][],
}


const charts: ("time" | "attempts" | "status")[] = ["attempts", "time", "status"];
export const StatisticsCharts = observer((props: IStatisticsGraphsProps): JSX.Element => {
  const { t }      = useTranslation();
  const { }        = props;
  const { toast }  = React.useContext(SnackBarContext);
  const tree: Tree = React.useContext(TreeContext);

  const [activeChart, setActiveChart] = React.useState<number>(null);
  const default_charts: React.ComponentType<IChartProps>[] = [AttemptsChart, TimeChart, StatusChart];

  const imageList_items: (IChartImageItemProps & {key: string | number, disabled: boolean})[] = [
    {
      title:     t('completion_attempts'),
      desc:      t('attempt_chart_desc'),
      component: (React.createElement(default_charts[0], {preview: true})),
      key:       1,
      disabled:  false,
    },{
      title:     t('completion_time'),
      desc:      t('time_chart_desc'),
      component: (React.createElement(default_charts[1], {preview: true})),
      key:       2,
      disabled:  false,
    },{
      title:     t('completion_status'),
      desc:      t('status_chart_desc'),
      component: (React.createElement(default_charts[2], {preview: true})),
      key:       3,
      disabled:  false,
    },
  ]

  return (
    <Box width="100%">
      {activeChart != null ?
        <Box>
          <Box display="flex" flexDirection="row" justifyContent="space-between" position="relative">
            <Button
              color     = 'secondary'
              startIcon = {<Icon iconId='arrow-left' />}
              variant   = "text"
              onClick   = {() => setActiveChart(null)}
            >
              {t('select_chart')}
            </Button>
            <ChartToolbar chartType={activeChart != null ? charts[activeChart] : undefined} />
          </Box>
          <ChartCSSOverwrite height="35rem" mt={1}>
            {React.createElement(default_charts[activeChart])}
          </ChartCSSOverwrite>
        </Box>
        :
            <ImageList cols={3} gap={8}>
          {imageList_items.map((c, idx) => (
            <ChartImageItem {...c} onClick={() => setActiveChart(idx)} />
          ))}
            </ImageList>
      }
    </Box>
  );
});

const ChartCSSOverwrite = styled(Box)`
  .apexcharts-menu-icon {
    border:        1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding:       7px;
    display:       flex;
    width:         fit-content;
    height:        fit-content;
    transform:     scale(1);
    color:         rgba(0, 0, 0, 0.54);

    svg {
      fill: rgba(0, 0, 0, 0.54);
    }

    :hover {
      background: rgba(0, 0, 0, 0.04);
    }

  }
`;